import { useEffect, useRef } from 'react';
export const useReferenceElement = ({ onClick, onMouseOver, onMouseLeave, }) => {
    const referenceElement = useRef(null);
    useEffect(() => {
        if (referenceElement.current) {
            referenceElement.current.onclick = onClick;
            referenceElement.current.onmouseover = onMouseOver;
            referenceElement.current.onmouseleave = onMouseLeave;
        }
        return () => {
            referenceElement.current?.removeEventListener('click', onClick);
            referenceElement.current?.removeEventListener('mouseover', onMouseOver);
            referenceElement.current?.removeEventListener('mouseleave', onMouseLeave);
        };
    }, [referenceElement, onClick, onMouseOver, onMouseLeave]);
    return referenceElement;
};
